import fluidityBalance from './fluidityBalance';
import salaryManage from './salaryManage';
import specialOutlay from './specialOutlay';
import recurrentOutlay from './recurrentOutlay';
import bankAccount from './bankAccount';
import revenueGoal from './revenueGoal';
import tradeStatement from './tradeStatement';
import taxCreditInvoice from './taxCreditInvoice';
import loanManage from './loanManage';
import reimbursementInvoice from './reimbursementInvoice';

export default (siteName) => [
    // ------------------- 小幫手 -------------------
    {
        path: 'payment-calendar',
        name: 'payment-calendar',
        component: () => import('../../components/dashboard/Finance/PaymentCalendar/index.vue'),
        meta: {
            title: `收支日曆${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'currency',
        name: 'currency',
        component: () => import('../../components/dashboard/Finance/Currency/index.vue'),
        meta: {
            title: `幣別與匯率${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'invoice-serial-number',
        name: 'invoice-serial-number',
        component: () => import('../../components/dashboard/Finance/InvoiceSerialNumber/index.vue'),
        meta: {
            title: `發票字軌管理${siteName}`,
            activeMenu: 'settings',
        },
    },

    // ------------------- 財務設定 -------------------
    // 特定費用
    ...specialOutlay(siteName),
    // 經常性費用
    ...recurrentOutlay(siteName),
    // 銀行帳戶
    ...bankAccount(siteName),
    // 收支項目設定
    ...tradeStatement(siteName),
    // 營收目標設定
    ...revenueGoal(siteName),

    // 審核流程設定
    {
        path: 'audit-flow',
        name: 'audit-flow',
        component: () => import('../../components/dashboard/Settings/AuditFlowSetting/index.vue'),
        meta: {
            title: `審核流程${siteName}`,
            activeMenu: 'settings',
        },
    },
    // 公司資訊設定
    {
        path: 'company-info',
        name: 'company-info',
        component: () => import('../../components/dashboard/Settings/CompanyInfoSetting/index.vue'),
        meta: {
            title: `公司資訊設定${siteName}`,
            activeMenu: 'settings',
        },
    },

    // ------------------- 財務設定 -------------------
    // 財務收支管理
    ...fluidityBalance(siteName),
    // 零用現金管理
    {
        path: 'petty-cash',
        name: 'petty-cash',
        component: () => import('../../components/dashboard/Finance/PettyCash/indexPage.vue'),
        meta: {
            title: `零用現金管理${siteName}`,
            activeMenu: 'finance',
        },
    },
    // 人事薪資管理
    ...salaryManage(siteName),
    // 銀行匯款明細、匯費
    {
        path: 'remittances',
        name: 'remittances',
        component: () => import('../../components/dashboard/Finance/Remittances/index.vue'),
        meta: {
            title: `銀行匯款明細、匯費${siteName}`,
            activeMenu: 'finance',
        },
    },
    // 外部進項發票
    ...taxCreditInvoice(siteName),

    // 借款管理
    ...loanManage(siteName),

    // 核銷轉開發票
    ...reimbursementInvoice(siteName),
];
